/* eslint-disable */

import { ELanguages } from "../../core/enums/Languages.enum";
import { ILanguages } from "../../core/interfaces/default.interface";

export function reshapeDataByTranslate(data: any): ILanguages {
  if (data.translates) {
    return {
      uz: data.translates.find((item: any) => item.lang == ELanguages.UZ) || {},
      crl:
        data.translates.find((item: any) => item.lang == ELanguages.UZ_CYRL) ||
        {},
      ru: data.translates.find((item: any) => item.lang == ELanguages.RU) || {},
    };
  } else {
    return {
      uz: {},
      crl: {},
      ru: {},
    };
  }
}
